// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Nar-r","title":"Info_title__1tpnE","links":"Info_links__3-hpl","link":"Info_link__1EP1Z","logo":"Info_logo__3Eo2h"};